if (!customElements.get('bnpl-installments')) {
  customElements.define(
    'bnpl-installments',
    class BnplInstallments extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('[data-bnpl-modal]');
        this.frame = this.querySelector('[data-bnpl-frame]');
        this.tamaraWidget = this.querySelector('[data-bnpl-tamara]');
        this.prices = this.parsePrices();
        this.amount = this.dataset.amount;

        // The product column animates with a transform, and a transformed ancestor makes
        // `position: fixed` resolve against it — so the modal has to hang off the body.
        if (this.modal) document.body.appendChild(this.modal);

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);

        this.querySelectorAll('[data-bnpl-open]').forEach((button) => {
          button.addEventListener('click', this.onOpen);
        });
        this.modal?.querySelectorAll('[data-bnpl-close]').forEach((element) => {
          element.addEventListener('click', this.onClose);
        });
        this.modal?.addEventListener('click', (event) => {
          if (event.target === this.modal) this.onClose();
        });

        // The theme dispatches a bubbling `change` on the variant input after every swap.
        // Cart placements carry no price map, so they have nothing to listen for.
        if (Object.keys(this.prices).length) {
          this.variantScope = this.closest('product-info') || document;
          this.variantScope.addEventListener('change', this.onVariantChange);
        }
      }

      disconnectedCallback() {
        this.variantScope?.removeEventListener('change', this.onVariantChange);
        document.removeEventListener('keydown', this.onKeydown);
        document.body.classList.remove('overflow-hidden');
        this.modal?.remove();
      }

      parsePrices() {
        try {
          return JSON.parse(this.querySelector('[data-bnpl-prices]').textContent);
        } catch (error) {
          return {};
        }
      }

      onVariantChange(event) {
        if (event.target.name !== 'id') return;

        const amount = this.prices[event.target.value];
        if (!amount || amount === this.amount) return;

        this.amount = amount;

        if (this.tamaraWidget) {
          this.tamaraWidget.setAttribute('amount', amount);
          // `amount` alone is not observed by the widget; refresh() re-renders it.
          window.TamaraWidgetV2?.refresh();
        }
      }

      onOpen(event) {
        const provider = event.currentTarget.dataset.bnplOpen;

        if (provider === 'tamara') {
          this.openTamara();
        } else {
          this.openTabby();
        }
      }

      openTabby() {
        if (!this.modal || !this.frame) return;

        this.frame.src = this.dataset.tabbyUrl + '&price=' + encodeURIComponent(this.amount);
        this.modal.hidden = false;
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.onKeydown);
        this.modal.querySelector('[data-bnpl-close]')?.focus();
      }

      // Tamara has no stand-alone popup URL, so its own widget opens it. The widget fills its
      // shadow root asynchronously, hence the short wait before giving up on the click.
      openTamara(attempt = 0) {
        const root = this.tamaraWidget?.shadowRoot;
        const target =
          root?.querySelector('.widget__container') ||
          root?.querySelector('.tamara-inline-learn-more-link') ||
          root?.querySelector('[class*="learn-more"]') ||
          root?.firstElementChild;

        if (target) {
          target.click();
          return;
        }

        if (attempt < 15) {
          setTimeout(() => this.openTamara(attempt + 1), 200);
        }
      }

      onClose() {
        if (!this.modal) return;

        this.modal.hidden = true;
        this.frame.src = 'about:blank';
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.onKeydown);
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.onClose();
      }
    }
  );
}
